import { DynamicIcon } from 'src/components';
import { isStringBooleanTrue } from 'src/utils/strings';

export const BooleanCell = ({ value }: { value: string | boolean }) => {
  const isTruthy = isStringBooleanTrue(value);

  return (
    <DynamicIcon
      sx={{
        color: (theme) =>
          isTruthy ? theme.palette.custom.OV.sys.success : theme.palette.custom.OV.sys.error,
      }}
      name={isTruthy ? 'check' : 'close'}
    />
  );
};
